import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { getOrganizationsInfo } from '~apis/organizations';
import { useCompanyId } from '~hooks/useCompanyId';

interface CompanyIdentifier {
  companyId: string;
}

export const OrganizationsQueryKey = {
  default: () => ['organizations'],
  info: ({ companyId }: CompanyIdentifier) => [
    ...OrganizationsQueryKey.default(),
    'info',
    companyId,
  ],
};

export function useGetOrganizationsInfo<TData = Awaited<ReturnType<typeof getOrganizationsInfo>>>(
  options?: Omit<
    UseQueryOptions<
      Awaited<ReturnType<typeof getOrganizationsInfo>>,
      Error,
      TData,
      ReturnType<typeof OrganizationsQueryKey.info>
    >,
    'queryKey' | 'queryFn'
  >,
) {
  const { companyId } = useCompanyId();
  return useQuery({
    queryKey: OrganizationsQueryKey.info({ companyId }),
    queryFn: () => getOrganizationsInfo(companyId),
    enabled: !!companyId,
    ...options,
  });
}
